import { createIdSchema } from "@/schemas/createId";
import { isoDateSchema } from "@/types/isoDate";
import z from "zod";

/** What any ATS can serve. */
export const EducationBaseSchema = z.object({
  id: z.string(),
  major: z.string(),
  degree: z.string(),
  startDate: isoDateSchema.nullable(),
  endDate: isoDateSchema.nullable(),
});
export type EducationBase = z.infer<typeof EducationBaseSchema>;

/** Core references its own catalogs and keeps a GPA. */
export const EducationSchema = EducationBaseSchema.extend({
  gpa: z.string().nullish(),
  gpaOutOf: z.string().nullish(),
  schoolId: z.string().nullable(),
  schoolCustom: z.string().nullable(),
});
export type Education = z.infer<typeof EducationSchema>;

// Send schoolId to reference a catalog school, or schoolCustom to create/reuse
// a custom one. Sending both is fine — schoolId wins — but neither is
// meaningless, since the read hides education that has no school.
export const EducationCreateSchema = z
  .strictObject({
    ...EducationSchema.shape,
    id: createIdSchema,
    schoolId: z.string().nullish(),
    // trim + min(1) so whitespace cannot mint a blank school in the shared catalog
    schoolCustom: z.string().trim().min(1).nullish(),
  })
  .refine((entry) => Boolean(entry.schoolId) || Boolean(entry.schoolCustom), {
    message:
      "Provide schoolId for a catalog school or schoolCustom for a custom one",
  });
export type EducationCreate = z.infer<typeof EducationCreateSchema>;
